import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';

import { T } from '../../../../constants';
import { useStore, useTranslation } from '../../../../hooks';
import { LaunchErrorCodes } from '../../../../enums';
import { env } from '../../../../environment';

import PascalLogo from '../../../../assets/media/logos/pascal-logo-not-found.png';
import TronixLogo from '../../../../assets/media/logos/tronix.png';

import './style.scss';

interface DefaultErrorPageProps {
  exitUrl?: string;
  isTronix: boolean;
  gameLogoUrl?: string;
  showPascalLogo: boolean;
  errorCode?: LaunchErrorCodes;
}

export const DefaultErrorPage: React.FC<DefaultErrorPageProps> = observer(({
  exitUrl,
  isTronix,
  errorCode,
  gameLogoUrl,
  showPascalLogo,
}) => {
  const t = useTranslation();
  const { gameStore } = useStore();
  const { gameErrorInfo, relaunchPending } = gameStore;

  const onRefreshClick = useCallback(() => {
    // reloadGame keeps relaunchPending truthful whether it relaunches now or defers to the cooldown.
    gameStore.reloadGame();
  }, [gameStore]);

  const renderActionButton = () => {

    if (errorCode === LaunchErrorCodes.GENERAL_ERROR) {
      return (
        <button
          type="button"
          className="not-found-btn"
          onClick={onRefreshClick}
          disabled={relaunchPending}
        >
          {t(relaunchPending ? T.RELOADING : T.REFRESH)}
        </button>
      );
    }

    if (exitUrl) {
      return (
        <a href={exitUrl} className="not-found-btn">
          {t(T.GO_TO_LOBBY)}
        </a>
      );
    }

    return null;
  };

  return (
    <div className={`not-found-page ${isTronix ? 'tronix' : ''}`}>
      <div className="not-found-page-content">
        {gameLogoUrl && (
          <div className="not-found-game-logo">
            <img alt="game-logo" src={`${env.origin}${gameLogoUrl}`} />
          </div>
        )}

        {/* gameErrorInfo holds translation aliases (`${errorMessage}_TEXT`), so translate like ErrorPopup does. */}
        {gameErrorInfo?.title && <h1 className="not-found-title">{t(gameErrorInfo.title)}</h1>}
        <p className="not-found-message">{gameErrorInfo?.text ? t(gameErrorInfo.text) : ''}</p>
        {gameErrorInfo?.displayErrorCode && (
          <span className="not-found-code">
            {gameErrorInfo.displayErrorCode}
          </span>
        )}

        {renderActionButton()}
      </div>

      {showPascalLogo && (
        <div className="not-found-footer">
          <img
            className="not-found-pascal-logo"
            src={isTronix ? TronixLogo : PascalLogo}
            alt="provider-logo"
          />
        </div>
      )}
    </div>
  );
});